(function(){
  function rb(){
    try{
      var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n,a=[];
      while(n=w.nextNode()){ var p=n.parentNode; if(n.nodeValue && /groundwork/i.test(n.nodeValue) && p && p.nodeName!=='SCRIPT' && p.nodeName!=='STYLE') a.push(n); }
      a.forEach(function(t){ t.nodeValue=t.nodeValue.replace(/GROUNDWORK/g,'SOLEWORK').replace(/Groundwork/g,'Solework'); });
      [].slice.call(document.querySelectorAll('[alt*="Groundwork"],[aria-label*="Groundwork"],[title*="Groundwork"]')).forEach(function(el){
        ['alt','aria-label','title'].forEach(function(at){ var v=el.getAttribute(at); if(v && /Groundwork/i.test(v)) el.setAttribute(at, v.replace(/GROUNDWORK/g,'SOLEWORK').replace(/Groundwork/g,'Solework')); });
      });
    }catch(e){}
  }
  if(document.readyState!=='loading') rb(); else document.addEventListener('DOMContentLoaded', rb);
})();
